import React, { FC } from "react";

import CardTable from "@components/common/CardTable";
import { Typography } from "@components/base";

interface ReportsProps {
  columns: CardTable["columns"];
  rows: CardTable["rows"];
  isLoaded: boolean;
  title: string;
  type: string;
  noReportsText: string;
  fillFormText: string;
}

const Reports: FC<ReportsProps> = ({
  columns,
  rows,
  isLoaded,
  title,
  type,
  noReportsText,
  fillFormText
}) => (
  <CardTable
    title={title}
    type={type}
    columns={columns}
    rows={rows}
    isLoaded={isLoaded}
    placeholderText={
      <Typography>
        {noReportsText}
        <br />
        {fillFormText}
      </Typography>
    }
  />
);

export default Reports;
